"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const formik_1 = require("formik");
const RenderEdithTextField = (props) => {
    const { field: { value, name, onChange, onBlur }, form: { touched, errors, setFieldValue, submitCount }, label, defaultValue, placeholder, inputVariant, submitOnEnter, characterLimit, rows, onInputBlur = () => undefined, ...otherProps } = props;
    const error = formik_1.getIn(errors, name);
    const touch = formik_1.getIn(touched, name);
    const [initState, setInitState] = react_1.useState(defaultValue);
    const displayErrors = (touch || submitCount > 0) && !!error;
    react_1.useEffect(() => {
        setInitState(defaultValue);
    }, [defaultValue, value]);
    const onKeyDown = (event) => {
        if (!submitOnEnter) {
            if (event.key == 'Enter') {
                event.preventDefault();
            }
        }
    };
    const handleOnBlur = (event) => {
        const value = event.target.value.trim();
        setFieldValue(name, value);
        onInputBlur(value);
        onBlur(event);
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(Box_1.default, null,
            react_1.default.createElement(TextField_1.default, Object.assign({ id: 'filled-helperText', multiline: rows > 1, rows: rows, name: name, label: label, variant: inputVariant, fullWidth: true, error: touch && !!error, 
                //value={value || ''}
                placeholder: placeholder, onChange: onChange, onBlur: handleOnBlur, onKeyDown: onKeyDown, defaultValue: initState, inputProps: { maxLength: characterLimit || undefined } }, otherProps)),
            characterLimit && (react_1.default.createElement(Typography_1.default, { style: { fontSize: '14px', color: '#9CA3AF' } },
                Number((value === null || value === void 0 ? void 0 : value.length) || 0).toLocaleString(),
                "/",
                Number(characterLimit).toLocaleString())),
            displayErrors && (react_1.default.createElement(Typography_1.default, Object.assign({ variant: "body2", component: "p", color: "error" }, otherProps), error)))));
};
RenderEdithTextField.defaultProps = {
    inputVariant: 'filled',
    submitOnEnter: false,
};
RenderEdithTextField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    label: prop_types_1.default.string.isRequired,
    placeholder: prop_types_1.default.string,
    submitOnEnter: prop_types_1.default.bool,
    characterLimit: prop_types_1.default.number,
    rows: prop_types_1.default.number,
};
exports.default = RenderEdithTextField;
